import { useSelector } from 'react-redux';

import { AppState } from '../../../../app.types';
import { DucsState } from './ducs-modal.types';

export const useDucsConfiguration = () => {
    return useSelector<AppState, DucsState>((state: AppState) => state.ducs);
};
